var app = angular.module("leonardo");

var AccountUserList = function($scope, $state, $filter, $http, $rootScope, $controller, ConfigThemeService, ngDialog, $q,
                               NavigationService, AccountUserService, AuthService, AuthDataService, FilterService,
                               PermissionService, NotificationService, RestangularProvider, AccountService, UserService, CacheService, $timeout) {

  $scope.permissionService = PermissionService;
  $scope.users = [];
  $scope.userExpanded = null;
  $scope.authDataService = AuthDataService;

  $scope.refreshResult = function(options, page) {
    if ($scope.isLoading) return;

    // Check if the page is already loaded
    if ($scope.loadedPages[page]) {
      if ($scope.visiblePages.includes(page)) {
        $scope.isLoading = false;
        return $q.resolve($scope.loadedPages[page]);
      }
    }

    $scope.isLoading = true;
    $scope.userExpanded = null;
    var params = $scope.getParams();
    angular.forEach(params, function(value, key){
      options[key] = value;
    });
    if (options && options.ordering == "client_instance__name") {
      options['order_by_clientinstance_name'] = 'asc';
      delete options.ordering;
    }
    else if (options && options.ordering == "-client_instance__name") {
      options['order_by_clientinstance_name'] = 'desc';
      delete options.ordering;
    }
    options.page = page;
    options.limit = $scope.pageSize;
    options['ordering'] = $scope.order;


    return UserService.getlist(options).then(function(data) {
      $scope.isLoading = false;

      if (data) {
        // Add the new page to our cache
        $scope.loadedPages[page] = data;
        
        // Add this page to visible pages
        if (!$scope.visiblePages.includes(page)) {
          $scope.visiblePages.push(page);
          $scope.visiblePages.sort(function(a, b) { return a - b; });
        }
        
        // Remove oldest or newest page if we exceed our limit
        if ($scope.visiblePages.length > $scope.maxVisiblePages) {
          if ($scope._loadingPreviousPage) {
            var newestPage = $scope.visiblePages.pop();
            delete $scope.loadedPages[newestPage];
          } else {
            var oldestPage = $scope.visiblePages.shift();
            delete $scope.loadedPages[oldestPage];
          }
        }
        
        // Update the users list
        $scope.updateUsersList();
      }

      return data;
    }, function(error) {
      $scope.isLoading = false;
      console.error('Error loading users:', error);
      return $q.reject(error);
    });
  };
  
  // Helper function to update the users list from visible pages
  $scope.updateUsersList = function() {
    var allUsers = [];
    $scope.visiblePages.forEach(function(pageNum) {
      if ($scope.loadedPages[pageNum]) {
        allUsers = allUsers.concat($scope.loadedPages[pageNum]);
      }
    });
    
    var oldLength = $scope.users ? $scope.users.length : 0;
    var newLength = allUsers.length;
    var significantChange = Math.abs(newLength - oldLength) > 10;
    
    var scrollPos = 0;
    var container = document.getElementById('userListContainer');
    if (significantChange && container) {
      scrollPos = container.scrollTop;
    }
    
    $scope.users = allUsers;
  };

    // Function to load the next page (scroll down)
  $scope.loadNextPage = function() {
    // Don't proceed if we're already loading
    if ($scope.isLoading) return;
    
    // Get the highest visible page
    var maxPage = Math.max.apply(null, $scope.visiblePages);
    
    // Check if we've already loaded all data
    var currentPageData = $scope.loadedPages[maxPage];
    if (currentPageData && currentPageData.length < $scope.pageSize) {
      // If the current page has fewer items than the page size,
      //this means we've reached the end of the data, no need to load more
      return;
    }
    
    // Calculate the next page to load
    var nextPage = maxPage + 1;
    
    // Request the next page
    $scope.refreshResult({ page: nextPage }, nextPage).then(function() {
      // Update current page after successful load
      $scope.currentPage = nextPage;
    });
  };

  // Function to load the previous page (scrolling up)
  $scope.loadPreviousPage = function() {
    if ($scope.isLoading) return;
    
    var minPage = Math.min.apply(null, $scope.visiblePages);
    if (minPage > 1) {
      var prevPage = minPage - 1;
      
      if ($scope.loadedPages[prevPage]) {
        return;
      }
      
      $scope._loadingPreviousPage = true;
      
      // Request the previous page
      $scope.refreshResult({ page: prevPage }, prevPage).then(function(data) {
        // Update current page after successful load
        $scope.currentPage = prevPage;
        $scope._loadingPreviousPage = false;
        
        // Adjust scroll position to show the newly loaded data at the top
        setTimeout(function() {
          var container = document.getElementById('userListContainer');
          var scrollPosition = data.length * 50;
          container.scrollTop = scrollPosition;
        }, 0);
        
        // Apply scope changes
        if (!$scope.$$phase) {
          $scope.$apply();
        }
      }).catch(function(error) {
        console.error('Error loading previous page:', error);
        $scope._loadingPreviousPage = false;
      });
    } else {
      return;
    }
  };

  $scope.initScroll = function() {
    var container = document.getElementById('userListContainer');
    container.addEventListener('scroll', function() {
      // Ignore scroll events when a user form is expanded
      if ($scope.userExpanded !== null) {
        return;
      }
      
      var scrollBottom = Math.abs(container.scrollHeight - container.scrollTop - container.clientHeight) < 5;
      var scrollTop = container.scrollTop === 0;
      
      if (scrollBottom) {
        $scope.loadNextPage();
      } 
      else if (scrollTop) {
        $scope.loadPreviousPage();
      }
    });
  };
  // Function to initialize the first page
  $scope.init = function() {
    $scope.currentPage = 1;
    $scope.pageSize = 50;
    $scope.loadedPages = {};
    $scope.visiblePages = [1];
    $scope.isLoading = false;
    $scope.maxVisiblePages = 3;
    $scope.refreshResult({ page: $scope.currentPage }, $scope.currentPage).then(function() {
    });
  };

  $scope.isActive = function (accountUser) {
    if (isNull(accountUser.account_status)) {
      return accountUser.is_active;
    }
    else {
      return accountUser.is_active && (![AccountService.STATUS_REJECTED, AccountService.STATUS_PENDING].includes(accountUser.account_status.toString()));
    }
  };

  $scope.isAccountUserEditable = function(accountUser) {
    return (
      accountUser.editable &&
      PermissionService.permissionAvailable('permission_edit_user', accountUser) &&
      $scope.isActive(accountUser) &&
      (AccountUserService.currentAccountUser.user.id !== $scope.userExpanded)
    );
  };

  $scope.isAccountUserDeleteable = function(accountUser) {
    return (
      accountUser.editable &&
      PermissionService.permissionAvailable('permission_delete_user', accountUser) &&
      $scope.isActive(accountUser) &&
      (AccountUserService.currentAccountUser.user.id !== $scope.userExpanded)
    );
  };

  $scope.isAccountUserUnDeleteable = function(accountUser) {
    return (
      accountUser.editable &&
      PermissionService.permissionAvailable('permission_edit_user', accountUser) &&
      !$scope.isActive(accountUser) &&
      (AccountUserService.currentAccountUser.user.id !== $scope.userExpanded)
    );
  };

  $scope.isUserActive = function (user) {
    if(user){
      if (AuthService.user.id === user.id){
        return false;
      }
      if (AuthService.hasOldToken()) { return false; }
      var active = false;
      if (user.is_staff || user.is_white_label_admin) { return true;}
      angular.forEach(user.account_users, function (accountUser) {
        if ($scope.isActive(accountUser)) {
          active = true;
        }
      });
      return active;
    }
  };

  $scope.getParams = function() {
    $scope.params = {summary: true, with_externals: true, exclude: 'editable'};
    if (FilterService.hasFilter('role')) $scope.params['role'] = FilterService.getFilter('role');
    if (FilterService.hasFilter('client_instances', true)) $scope.params['client_instance'] = FilterService.getFilter('client_instances', true);
    if (FilterService.hasFilter('managed_by_reports')) $scope.params['managed_by'] = FilterService.getFilter('managed_by_reports');
    if (FilterService.hasFilter('active')) $scope.params['active'] = FilterService.getFilter('active');
    if (FilterService.hasFilter('user_search')) $scope.params['search'] = FilterService.getFilter('user_search');
    if (FilterService.hasFilter('account_reports')) $scope.params['account'] = FilterService.getFilter('account_reports');
    if (FilterService.hasFilter('group_reports')) $scope.params['group'] = FilterService.getFilter('group_reports');
    if (FilterService.hasFilter('portfolio_reports')) $scope.params['portfolio'] = FilterService.getFilter('portfolio_reports');
    if (FilterService.hasFilter('property_reports')) $scope.params['property'] = FilterService.getFilter('property_reports');
    return $scope.params;
  };

  $scope.workAsUser = function(user) {
    CacheService.clearAll();
    var url = ConfigThemeService.generateURL('/api/2.0/login-as/');
    $http.post(url, {login_as: user.id}).then(function(data){
      data = data.data;
      localStorage.setItem('jwt_token_old', localStorage.getItem('jwt_token'));
      localStorage.setItem('jwt_user_id_old', AuthService.user.id);
      localStorage.setItem('jwt_old_user', JSON.stringify(AuthService.user));
      localStorage.setItem('jwt_token', data.token);
      FilterService.resetFilters(true);
      NavigationService.goToLoginRedirectionWorkAs();
    });
  };

  $scope.getIndexUsers = function (id) {
    var index = -1;
    angular.forEach($scope.users, function (user, key) {
      if (user.id == id)
        index = key;
    });
    return index;
  };

  $scope.getToggledUser = function (user_id) {
      UserService.one(user_id).get().then(function (data) {
        var user_index = $scope.getIndexUsers(user_id);
        if (user_index >= 0) {
          $scope.users[user_index] = data;
        }
      });
  };

  $scope.toggleUser = function (user_id) {
    if ($scope.userExpanded === user_id)
      $scope.userExpanded = null;
    else {
      UserService.one(user_id).get().then(function (data) {
        var user_index = $scope.getIndexUsers(user_id);
        if (user_index >= 0) {
          $scope.users[user_index] = data;
          $scope.userExpanded = user_id;
        }
      });
    }
  };

  $scope.getCurrent = function(user) {
    var account_user = user.account_users && user.account_users.length > 0 ? user.account_users[0] : null;
    if (!account_user) {
      return user;
    }
    angular.forEach(user.account_users, function (account_user_element) {
      if (account_user_element.account && !account_user_element.managed_by){
        account_user = account_user_element;
      }
    });
    account_user.client_instance = user.client_instance;
    return account_user;
  };

  $scope.userIsExpanded = function(user_id) {
    return $scope.userExpanded && ($scope.userExpanded === user_id);
  };

  $scope.getUserRoles = function (user) {
    var types = '';
    if (user.is_staff || user.is_white_label_admin) return 'Admin';
    angular.forEach(user.account_users, function (accountUser) {
      if (accountUser.role) {
        if (accountUser.role_permissions_modified)
          types += '<span class="role-modified">';
        else
          types += '<span>';
        types += accountUser.role.name;
        types += '</span>, ';
      }
    });
    return types.slice(0, -2);
  };

  $scope.$on('account-user:deleted', function() {
    $scope.refreshResult({ page: $scope.currentPage }, $scope.currentPage);
    if ($scope.userExpanded) {
      updateUsersList();
    }
  });

  $scope.$on('account-user:undeleted', function() {
    $scope.refreshResult({ page: $scope.currentPage }, $scope.currentPage);
    if ($scope.userExpanded) {
      updateUsersList(true);
    }
  });

  function updateUsersList(noCancel) {
    UserService.get($scope.userExpanded, noCancel).then(function (data) {
      let user_index = $scope.getIndexUsers($scope.userExpanded);
      if (user_index >= 0) {
        $scope.users[user_index] = data;
      }
      $rootScope.$broadcast('users-list:updated');
    });
  }

  $scope.orderBy = function (order) {
    if ($scope.order !== order) {
      $scope.order = order;
    }
    else {
      $scope.order = '-' + order;
    }
    $scope.init();
  };

  $scope.$on('account-user-form:updated', function() {
    updateUsersList();
  });

   $timeout(function () {
    $scope.init();
  }, 0);

  $scope.$on('filter-selection:updated', function(){
    $scope.loadedPages = {};
    $scope.init();
    // Reset scroll position
    setTimeout(function() {
      var container = document.getElementById('userListContainer');
      if (container) {
        container.scrollTop = 0;
      }
  }, 100);
  });
};

app.controller('AccountUserList', ['$scope', '$state', '$filter', '$http', '$rootScope', '$controller', 'ConfigThemeService',
  'ngDialog', '$q', 'NavigationService', 'AccountUserService', 'AuthService', 'AuthDataService', 'FilterService',
  'PermissionService', 'NotificationService', 'Restangular', 'AccountService', 'UserService', 'CacheService', '$timeout', AccountUserList]);
